/* eslint-disable */
import './login.css';
import $ from 'jquery';
import 'bootstrap';

$(function () {
    var ipAddress = 'http://dsr.ai.dadaowl.cn'

    function checkEmpty(selector) {
        if (selector.val() == "" || selector.val() == selector.prop("placeholder")) {
            selector.addClass('formFieldError', 500);
            return false;
        } else {
            selector.removeClass('formFieldError', 500);
            return true;
        }
    }

    function validateEmail(email) {
        var regex = /^[a-zA-Z0-9._-]+@([a-zA-Z0-9.-]+\.)+[a-zA-Z0-9.-]{2,4}$/;
        if (!regex.test(email.val())) {
            email.addClass('formFieldError', 500);
            return false;
        } else {
            email.removeClass('formFieldError', 500);
            return true;
        }
    }

    function validatePhone(phone) {
        var regex = /^1[3456789]\d{9}$/

        if (!regex.test(phone.val())) {
            phone.addClass('formFieldError', 500);
            return false;
        } else {
            phone.removeClass('formFieldError', 500);
            return true;
        }
    }

    function makeErrorTip(el, msg) {
        if (!el.next('div')[0]) {
            el.after('<div class="error-tip">' + msg + '</div>')
        }
    }

    $.fn.serializeJson = function () {
        var serializeObj = {};
        var array = this.serializeArray();
        var str = this.serialize();
        $(array).each(function () {
            if (serializeObj[this.name]) {
                if ($.isArray(serializeObj[this.name])) {
                    serializeObj[this.name].push(this.value);
                } else {
                    serializeObj[this.name] = [serializeObj[this.name], this.value];
                }
            } else {
                serializeObj[this.name] = this.value;
            }
        });

        return serializeObj;
    };

    $('#getCode').on('click', function () {
        if (!validatePhone($('#username'))) {
            makeErrorTip($('#username'), '请输入正确的手机号码')
            return
        }

        $.ajax({
            url: ipAddress + "/pddUserReg/cms/send?username=" + $('#username').val(),
            type: "GET",
            cache: false,
            contentType: 'application/json',
            success: function (res) {
                $('#result-message').removeClass('alert-success').removeClass('alert-danger')

                if (res.code == 200) {
                    $('#result-message').addClass('alert alert-success').html('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + res.msg).delay(500).slideDown(500).delay(10000).slideUp('slow');

                } else {
                    $('#result-message').addClass('alert alert-danger').html('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + res.msg).delay(500).slideDown(500).delay(10000).slideUp('slow');
                }
            },
            error: function (a, b) {
                if (b == 'error') {
                    $('#result-message').addClass('alert alert-danger').html('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + res.msg).delay(500).slideDown(500).delay(10000).slideUp('slow');
                };
            }
        });
    })

    $('#username, #ident_code, #password, #repassword').on('focus', function () {
        if ($(this).hasClass('formFieldError')) {
            $(this).next().remove()
        }

        $(this).removeClass('formFieldError')
    })

    $('#check').on('change', function () {
        if ($('.agreement').next().hasClass('error-tip')) {
            $('.agreement').next().remove()
        }
    })

    $('.login-form').submit(function () {
        var $this = $(this),
            result = true;

        if (!$this.find('#check').prop('checked')) {
            makeErrorTip($this.find('.agreement'), '请阅读并同意使用协议')
            result = false;
        }

        if (!validatePhone($this.find('#username'))) {
            makeErrorTip($this.find('#username'), '请输入正确的手机号码')
            result = false;
        }

        if (!checkEmpty($this.find('#ident_code'))) {
            makeErrorTip($this.find('#ident_code'), '验证码不能为空')
            result = false;
        }

        if (!checkEmpty($this.find('#password'))) {
            makeErrorTip($this.find('#password'), '密码不能为空')
            result = false;
        }

        if (!checkEmpty($this.find('#repassword'))) {
            makeErrorTip($this.find('#repassword'), '确认密码不能为空')
            result = false;
        }

        if ($this.find('#password').val() != $this.find('#repassword').val()) {
            $this.find('#repassword').addClass('formFieldError', 500)
            makeErrorTip($this.find('#repassword'), '两次密码输入不一致')

            result = false
        } else {
            if ($this.find('password').val()) {
                $this.find('#password').next().remove()
                $this.find('#password').removeClass('formFieldError')
                $this.find('#repassword').next().remove()
                $this.find('#repassword').removeClass('formFieldError')

                result = true
            }
        }

        if (result == false) {
            return false;
        }

        $('.submit-btn').text('注册中...')

        var data = $this.serializeJson();

        delete data.repassword

        $.ajax({
            url: ipAddress + "/pddUserReg/cms/reg",
            type: "POST",
            data: JSON.stringify(data),
            cache: false,
            contentType: 'application/json',
            success: function (res) {
                if (res.code == 200) {
                    $('.mask').fadeIn('slow').css('display', 'flex')

                    $('.submit-btn').text('立即注册')

                } else {
                    $('#result-message').addClass('alert alert-danger').html('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + res.msg).delay(500).slideDown(500).delay(10000).slideUp('slow');
                    $('.submit-btn').text('立即注册')
                }
            },
            error: function (a, b) {
                if (b == 'error') {
                    $('#result-message').addClass('alert alert-danger').html('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + res.msg).delay(500).slideDown(500).delay(10000).slideUp('slow');
                };
                $('.submit-btn').text('立即注册')
            }
        });

        return false
    });

    $('.doclose').on('click', function () {
        $('.mask').fadeOut('hide')
    })
})